export const colors = {
  primary: "#ef5350",
  light: "#ff867c",
  dark: "#b61827",
  white: "#fff",
  black: "#000",
  gray: "#E0E0E0",
  gray600: "#757575",
  gray700: "#455A64",
};

export const fontsSize = {
  sm: 12,
  md: 16,
  lg: 22,
};

export const fonts = {
  bold: "DMSans-Bold",
  medium: "DMSans-Medium",
  regular: "DMSans-Regular",
};
